'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { getDayList } from '@mui/x-scheduler-internals/get-day-list';
import { getStartOfWeek, getEndOfWeek } from '@mui/x-scheduler-internals/internals';
import { schedulerOtherSelectors } from '@mui/x-scheduler-internals/scheduler-selectors';
import { eventCalendarPreferenceSelectors } from '@mui/x-scheduler-internals/event-calendar-selectors';
import { useEventCalendarView } from '@mui/x-scheduler-internals/use-event-calendar-view';
import { createSelectorMemoized } from '@base-ui/utils/store';
import { DayTimeGrid } from "../internals/components/day-time-grid/DayTimeGrid.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const WEEK_VIEW_CONFIG = {
  siblingVisibleDateGetter: ({
    state,
    delta
  }) => state.adapter.addWeeks(getStartOfWeek(state.adapter, schedulerOtherSelectors.visibleDate(state), eventCalendarPreferenceSelectors.weekStartsOn(state)), delta),
  visibleDaysSelector: createSelectorMemoized(state => state.adapter, schedulerOtherSelectors.visibleDate, eventCalendarPreferenceSelectors.showWeekends, eventCalendarPreferenceSelectors.weekStartsOn, (adapter, visibleDate, showWeekends, weekStartsOn) => getDayList({
    adapter,
    start: getStartOfWeek(adapter, visibleDate, weekStartsOn),
    end: getEndOfWeek(adapter, visibleDate, weekStartsOn),
    excludeWeekends: !showWeekends
  }))
};

/**
 * A Week View to use inside the Event Calendar.
 */
export const WeekView = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function WeekView(props, forwardedRef) {
  // Feature hooks
  const {
    days
  } = useEventCalendarView(WEEK_VIEW_CONFIG);
  return /*#__PURE__*/_jsx(DayTimeGrid, _extends({
    ref: forwardedRef,
    days: days
  }, props));
}));
if (process.env.NODE_ENV !== "production") WeekView.displayName = "WeekView";